import { apiPost } from '../../utils/api';
import { AccountProps } from './containers/ProvisionVoCAccount';

export const createProvisioningAccount = async (accountProps: AccountProps) => {
  return apiPost('/accounts/provision_cs', undefined, accountProps);
};
